import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import AddAssetButton from "./components/AddAssetButton";
import SendDataButton from "./components/SendDataButton";
import ExportAllButton from "./components/ExportAllButton";

import { Stack, Typography } from "@components/base";

interface Header {}

const Header: FC<Header> = () => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="subtitle1">
        {t("csob.questionnaires.table.title")}
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <AddAssetButton />
        <ExportAllButton />
        <SendDataButton />
      </Stack>
    </Stack>
  );
};

export default Header;
